import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { SyncCenterComponent } from '@modules/shared/sync-center/sync-center.component';
import { ActionStatus } from '@pixacare/shared';
import { rollupSyncActionState } from '@shared/store/sync/utils/rollup-sync-action-state';
import { TuiButton, TuiDropdown } from '@taiga-ui/core';
import { Size } from '../../../../shared/models/enums/size.enum';
import { SyncActionChildKey } from '../models/sync-action-child-key';
import { SyncActionDisplay } from '../models/sync-action-display';
import { SyncCenterStateService } from '../sync-center-state.service';
import { SyncGlobalStatusIconComponent } from '../sync-global-status-icon/sync-global-status-icon.component';

@Component({
  selector: 'pxc-sync-center-button',
  templateUrl: './sync-center-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoModule, TuiButton, TuiDropdown, SyncCenterComponent, SyncGlobalStatusIconComponent],
})
export class SyncCenterButtonComponent {
  protected readonly syncCenterState = inject(SyncCenterStateService);
  readonly items = input<SyncActionDisplay[]>([]);
  readonly resumeChild = output<SyncActionChildKey>();
  readonly retryChild = output<SyncActionChildKey>();
  readonly deleteChild = output<SyncActionChildKey>();
  protected readonly ActionStatus = ActionStatus;
  readonly Size = Size;

  protected readonly globalSyncStatus = computed(
    () => rollupSyncActionState(this.items().map((item) => item.state)).status,
  );
}
